import { ErrorLike } from '@apollo/client';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const useQueryErrorToast = (error: ErrorLike | undefined, message?: string) => {
  useEffect(() => {
    if (error) {
      toast.error(message ?? error.message);
    }
  }, [error, message]);
};
